const state = function() {
  return {
    isMobile: false,
  };
};

export default state;


// WEBPACK FOOTER //
// ./src/common/mobile/vuex/state.js